export const NAVBAR_HIDE_SCROLL_THRESHOLD = 420;
export const NAVBAR_BG_SCROLL_THRESHOLD = 180;

export const NAVBAR_HIDE_TRANSITION = {
  ease: "easeInOut",
  duration: 0.5,
} as const;

export const SCROLL_SPY_TOP_PADDING = 16;
export const SCROLL_SPY_FALLBACK_OFFSET = -120;

export function getSiteNavbarScrollOffset(
  extraPadding = SCROLL_SPY_TOP_PADDING,
): number {
  if (typeof document === "undefined") {
    return SCROLL_SPY_FALLBACK_OFFSET;
  }

  const navbar = document.getElementById("site-navbar");
  if (!navbar) {
    return SCROLL_SPY_FALLBACK_OFFSET;
  }

  // Layout height, not getBoundingClientRect().bottom — the navbar slides off-screen
  // with transform when hidden, which would under-count offset on the first scroll-up
  // TOC click before it animates back into view.
  return -(navbar.offsetHeight + extraPadding);
}
